import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import PageContainer from '@/components/Container/PageContainer';
import { getMeetingDetail, joinMeeting, joinMeetingForGuest } from '@/api/event.api';

import { useAppSelector } from '@/redux/store.hook';
import { getAuthSelector } from '@/redux/auth/auth.slice';
import { errorHandler } from '@/utils/toastHandler';
import { useTranslation } from 'react-i18next';
import useCurrentLang from '@/hooks/useCurrentLang';
import { dmpMeetingFailure } from '@/utils/dmpMeeting';

const JoinMeeting = () => {
  // @ts-ignore
  const { t, i18n } = useTranslation();
  const lang = useCurrentLang();

  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const auth = useAppSelector(getAuthSelector);

  useEffect(() => {
    getDeatil();
  }, []);

  const getDeatil = async () => {
    const meetingID = searchParams.get('meetingID');

    if (!meetingID) {
      errorHandler(t('error.server'));
      navigate('/home');
      return;
    }

    if (auth.isLogin) {
      getHostLink(meetingID!);
    } else {
      getGuestLink(meetingID!);
    }
  };

  const getGuestLink = async (meetingID: string) => {
    try {
      const res = (await joinMeetingForGuest(meetingID, i18n.language)).data;
      if (!res.success || typeof res.data !== 'string' || !['https:', 'http:'].includes(new URL(res.data).protocol)) throw { response: { data: res } };
      window.location.href = res.data;
    } catch (err) {
      errorHandler(dmpMeetingFailure(err, lang === 'en'));
      window.location.href = '/';
    }
  };

  const getHostLink = async (meetingID: string) => {
    try {
      const reqData = `meetingID=${encodeURIComponent(meetingID)}&locale=${encodeURIComponent(i18n.language)}`;
      const res = (await joinMeeting(reqData)).data;
      if (!res.success || typeof res.data !== 'string' || !['https:', 'http:'].includes(new URL(res.data).protocol)) throw { response: { data: res } };
      window.location.href = res.data;
    } catch (error) {
      errorHandler(dmpMeetingFailure(error, lang === 'en'));
      navigate('/home');
    }
  };

  return <PageContainer children={<></>} title={'Redirecting...'}></PageContainer>;
};

export default JoinMeeting;
